import axiosExternal from 'axios';
import { apiUrls } from '../../constants';
import { getExperienceInitCookie } from './../../common/utils/experienceInitCookie';
import { companySettingsProvider } from '../../store/providers/companySettingsProvider';

export const tcPlusCompanySettings = async (tcPlusFlow: boolean): Promise<{ data?: string[]; error: string }> => {
  if (tcPlusFlow) {
    const { setCompanySettings } = companySettingsProvider();
    const expCookie = getExperienceInitCookie();
    const companyId = expCookie && expCookie.companyId;
    const companyUserId = expCookie && expCookie.companyUserId;
    try {
      const response = await axiosExternal.get(apiUrls.GET_COMPANY_SETTINGS, {
        params: { companyId, companyUserId },
        headers: { 'X-Api-AuthToken': process.env.REACT_APP_API2_AUTH_TOKEN },
      });
      if (response.status === 200) {
        setCompanySettings(response.data.data);
      }
      return {
        error: '',
      };
    } catch (e) {
      console.log(e);
    }
  }
  return {
    error: '',
  };
};
